import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import HowToPlaySlide from "./HowToPlaySlide";
import Slide1 from "../../assets/HowToPlayIcon1.svg";
import Slide2 from "../../assets/HowToPlayIcon2.svg";
import Slide3 from "../../assets/HowToPlayIcon3.svg";
import CustomText from "../CustomText";
import Colors from "../../config/Colors";
import { isMobile } from "../../types/type";

function HowToPlayCarousel() {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
      slidesToSlide: 5, // optional, default to 1.
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const settings = {
    responsive: responsive,
    autoPlay: false,
    showDots: false,
    arrows: false,
  };

  return (
    <div className="cardCarousel">
      <div className="flex justifyCenter ">
        <CustomText
          spacing={4}
          size="mediumLarge"
          weight="400"
          color={Colors.blueGray}
          marginBottom={20}
        >
          GAME RULES
        </CustomText>
      </div>
      <div className="cardCarouselContent1">
        <Carousel {...settings} autoPlay={true} infinite={true}>
          <HowToPlaySlide
            icon={<img src={Slide1} alt="icon" className="cardHowToPlayIcon" />}
            title="Predict & Win"
            textBottom={5}
            iconTop={-1}
            desciption={
              <div
                style={{
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Predict the outcome in 20s & Win Big
                </div>
                <div>1 Correct Prediction - 10 points</div>
                <div>2 Correct Predictions - 25 points</div>
                <div>All Correct Predictions - 50 points</div>
              </div>
            }
          />

          <HowToPlaySlide
            icon={
              <img
                src={Slide2}
                alt="icon"
                className="cardHowToPlayIcon"
                style={{ height: 150 }}
              />
            }
            title="Prizes worth 10 Lakh"
            textBottom={5}
            iconTop={30}
            desciption={
              <div>
                <p style={{ textAlign: "center", marginBottom: 10 }}>
                  Top 20 weekly users receive ₹5000 each in Ajio rewards
                </p>
                <p style={{ textAlign: "center" }}>
                  Top 40 IPL series users receive ₹10000 worth of Ajio rewards
                </p>
              </div>
            }
          />
          <HowToPlaySlide
            icon={
              <img
                src={Slide3}
                alt="icon"
                className="cardHowToPlayIcon"
                style={{ height: 180, marginLeft: 10 }}
              />
            }
            iconLeft={0}
            title={
              <>
                <>Fastest Fingers First</>
              </>
            }
            textBottom={20}
            iconTop={40}
            desciption={
              <div style={{ textAlign: "center" }}>
                Make quick decisions to stay at the top of the leaderboard
              </div>
            }
          />
        </Carousel>
      </div>

      <div className="cardCarouselContent2">
        <HowToPlaySlide
          icon={
            <img
              src={Slide1}
              alt="icon"
              className="cardHowToPlayIcon"
              style={{ height: 200 }}
            />
          }
          title="Predict & Win"
          textBottom={10}
          iconTop={0}
          desciption={
            <div
              style={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              Predict the outcome in 20s & Win Big
              <div>1 Correct Prediction - 10 points</div>
              <div>2 Correct Predictions - 25 points</div>
              <div>All Correct Predictions - 50 points</div>
            </div>
          }
        />

        <HowToPlaySlide
          icon={
            <img
              src={Slide2}
              alt="icon"
              className="cardHowToPlayIcon"
              style={{ height: 170 }}
            />
          }
          title="Prizes worth 10 Lakh"
          textBottom={5}
          iconTop={5}
          desciption={
            <div>
              <p style={{ textAlign: "center", marginBottom: 10 }}>
                Top 20 weekly users receive ₹5000 each in Ajio rewards
              </p>
              <p style={{ textAlign: "center" }}>
                Top 40 IPL series users receive ₹10000 worth of Ajio rewards
              </p>
            </div>
          }
        />

        <HowToPlaySlide
          icon={
            <img
              src={Slide3}
              alt="icon"
              className="cardHowToPlayIcon"
              style={{ height: 180 }}
            />
          }
          title={
            <>
              <>Fastest Fingers First</>
            </>
          }
          textBottom={20}
          iconTop={30}
          desciption={
            <div style={{ textAlign: "center" }}>
              Make quick decisions to stay at the top of the leaderboard
            </div>
          }
        />
      </div>
    </div>
  );
}

export default HowToPlayCarousel;
